import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import type { RootState } from "../store/index";
import { combineErrors, combineStatuses } from "../utils";
import {
  getCatalogueObjectInfoRequest,
  getCatalogueObjectsRequest,
  type CatalogueRequestKey,
} from "../store/catalogueDuck";

export function useCatalogue() {
  const dispatch = useDispatch();

  const { catalogue, object } = useSelector(
    (state: RootState) => state.catalogue,
  );

  const loadCatalogue = useCallback(
    (params?: {
      page?: number;
      pageSize?: number;
      filter?: string;
      sort?: string;
    }) => {
      dispatch(getCatalogueObjectsRequest(params));
    },
    [dispatch],
  );

  const getCatalogueObjectInfo = (id: string) => {
    dispatch(getCatalogueObjectInfoRequest({ id }));
  };

  const getRequestStatus = (
    request: CatalogueRequestKey | CatalogueRequestKey[],
  ) =>
    useSelector((state: RootState) => {
      const requests = Array.isArray(request) ? request : [request];
      return combineStatuses(
        requests.map((key) => state.catalogue.requests[key].status),
      );
    });

  const getRequestError = (
    request: CatalogueRequestKey | CatalogueRequestKey[],
  ) =>
    useSelector((state: RootState) => {
      const requests = Array.isArray(request) ? request : [request];

      return combineErrors(
        requests.map((key) => state.catalogue.requests[key].error),
      );
    });

  return {
    catalogue,
    object,
    loadCatalogue,
    getCatalogueObjectInfo,
    getRequestStatus,
    getRequestError,
  };
}
